import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { FormNumberInput } from 'src/components/FormPart/FormNumberInput';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormComponentProps } from 'src/components/FormPart/types';
import { FREE_CREDITS_OPENING_BALANCE_REASON } from '../../../helpers';
import { AdjustFreeCreditsFormData } from '../../../types';

type AdjustFreeCreditsFormProps = {
  balance: number;
};

export const AdjustFreeCreditsForm: FC<
  FormComponentProps<AdjustFreeCreditsFormData, AdjustFreeCreditsFormProps>
> = ({ form, balance }) => {
  const freeCredits = form.watch('freeCredits') || 0;
  const { isValid, isSubmitting } = form.formState;

  return (
    <Stack gap={2} sx={{ paddingTop: 1 }}>
      <Typography variant="body2">
        Current balance: {balance.toLocaleString()}
        <br />
        New balance: {(balance + freeCredits).toLocaleString()}
      </Typography>

      <FormNumberInput
        form={form}
        fieldName="freeCredits"
        label="Credits to add/subtract"
        helperText="Use a negative number to deduct credits"
        format={{ maximumFractionDigits: 0 }}
        fullWidth
        margin="none"
        validation={{
          required: 'Credits are required',
          validate: (value: number) => !!value || 'Enter a non-zero amount',
        }}
      />

      <FormTextInput
        form={form}
        fieldName="reason"
        label="Reason"
        multiline
        minRows={2}
        fullWidth
        margin="none"
        validation={{
          validate: (value: string) => {
            const reason = value.trim();
            if (reason.length === 0) return 'Reason is required';
            if (reason.toLowerCase() === FREE_CREDITS_OPENING_BALANCE_REASON.toLowerCase()) {
              return 'This reason is reserved for the opening balance';
            }
            return true;
          },
        }}
      />

      <Stack direction="row" justifyContent="flex-end">
        <Button
          type="submit"
          variant="contained"
          disabled={!isValid || isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} /> : null}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
